export default "__VITE_ASSET__BbcZ1ESd__"